import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceStatusPanel = ({ complianceData }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'compliant':
        return {
          color: 'text-success',
          bgColor: 'bg-success/10',
          icon: 'CheckCircle',
          label: 'Compliant'
        };
      case 'warning':
        return {
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          icon: 'AlertTriangle',
          label: 'Attention Required'
        };
      case 'critical':
        return {
          color: 'text-error',
          bgColor: 'bg-error/10',
          icon: 'XCircle',
          label: 'Non-Compliant'
        };
      default:
        return {
          color: 'text-muted-foreground',
          bgColor: 'bg-muted/10',
          icon: 'Info',
          label: 'Unknown'
        };
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Shield" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Compliance Status</h3>
            <p className="caption text-muted-foreground">Regulatory adherence monitoring</p>
          </div>
        </div>
      </div>
      <div className="space-y-3">
        {complianceData?.map((item) => {
          const config = getStatusConfig(item?.status);
          return (
            <div
              key={item?.id}
              className={`p-4 rounded-lg border border-border ${config?.bgColor} transition-smooth hover:shadow-sm`}
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                  <Icon name={config?.icon} size={18} className={config?.color} />
                  <h4 className="text-sm font-semibold text-foreground">{item?.category}</h4>
                </div>
                <span className={`text-xs font-semibold ${config?.color} uppercase`}>
                  {config?.label}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-3">{item?.description}</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div>
                    <p className="caption text-muted-foreground">Last Check</p>
                    <p className="text-sm font-medium text-foreground">{item?.lastCheck}</p>
                  </div>
                  <div>
                    <p className="caption text-muted-foreground">Next Review</p>
                    <p className="text-sm font-medium text-foreground">{item?.nextReview}</p>
                  </div>
                </div>
                {item?.action && (
                  <button className="text-sm font-medium text-primary hover:underline">
                    {item?.action}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComplianceStatusPanel;